<template>
  <div>
    <div class="suspensionContact">
      <div class="scitem">
        <div>
          <img class="scimg" src="@/assets/41.png" alt="">
          <p class="sctext">微信</p>
        </div>
        <div class="isshow">
          <div class="showinfowx">
            <p>请加我微信</p>
            <img src="@/assets/40.png" alt="">
          </div>
        </div>
      </div>
      <div class="scitem">
        <div>
          <img class="scimg" src="@/assets/42.png" alt="">
          <p class="sctext">QQ咨询</p>
        </div>
        <div class="isshow">
          <div class="showinfowx" @click="openurl">
            <div class="zixun">点咨询，我来帮您！</div>
          </div>
        </div>
      </div>
      <div class="scitem">
        <div>
          <img class="scimg" src="@/assets/43.png" alt="">
          <p class="sctext">电话</p>
        </div>
        <div class="isshow">
          <div class="showinfowx">
            <p>服务热线</p>
            <div class="call">150-3906-7451</div>
            <p>查货热线</p>
            <div class="call">131-4010-9120</div>
            <p>投诉热线</p>
            <div class="call">150-3808-8120 </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    openurl() {
      window.open('https://wpa1.qq.com/uQPPj3hl?_type=wpa&qidian=true');
    }
  }
};
</script>

<style lang="scss" scoped>
.suspensionContact {
  position: fixed;
  right: 30px;
  bottom: 120px;
  z-index: 990;
  box-sizing: border-box;
  border-radius: 10px;
  // padding: 20px 18px 28px 18px;

  .scitem {
    width: 55px;
    padding: 7px;
    cursor: pointer;
    position: relative;
    background: #77a4c8;
    border-bottom: 1px solid #FFF;

    &:hover>.isshow {
      display: block;
    }

    &:last-child {
      border-bottom: none;
    }

    .isshow {
      position: absolute;
      box-sizing: border-box;
      right: 100%;
      top: 50%;
      transform: translateY(-50%);
      padding-right: 15px;
      display: none;

      .showinfowx {
        padding: 10px;
        text-align: center;
        border-radius: 10px;
        background-color: #77a4c8;



        p {
          white-space: nowrap;
          color: #fff;
          font-size: 14px;
        }

        .zixun {
          font-size: 16px;
          color: #fff;
          white-space: nowrap;
          padding: 15px 0;
        }

        .call {
          font-size: 14px;
          background: #FFF;
          white-space: nowrap;
          padding: 4px 10px;
          text-align: center;
          margin: 5px 0;
        }

        img {
          width: 150px;
          margin-top: 10px;
          height: 150px;
        }
      }
    }


    .scimg {
      width: 25px;
      height: 25px;
      display: block;
      margin: auto;
    }

    .sctext {
      color: #FFF;
      text-align: center;
      font-size: 11px;
    }
  }
}
</style>